import React, { useEffect, useState } from 'react'
import { Button, Menu, Modal, Switch, Tooltip } from 'antd'

import { leftMenuToggle } from 'store/actions/home'
import { useActions } from 'hooks/useActions'

import Icon, { PlusOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { ReactSortable } from 'react-sortablejs'
import { getCurrentCompany } from '../../../../services/user'
import { useTranslation } from 'react-i18next'
import useResponsiveWidth from 'hooks/useResponsiveWidth'

interface ItemType {
    id: number
    title: string
    trnType: string
    path: string
    active: boolean
}

import { FasterMenuType } from '../../../../services/FasterMenus'

import {
    BookmarkIco,
    DraggableMoveUpDownIco,
    FasterMenuIco,
    ModalCloseIco,
} from '../../../../../modules/CustomIcons'
import { connect } from 'react-redux'
import {
    addFavoriteFastmenuData,
    deleteFavoriteFastmenuData,
    getFastmenuData,
    updateFastmenuData,
} from '../../../../store/actions/fastmenu'
import i18next from '../../../../../i18n'

const FasterMenus: React.FC<any> = ({
    leftMenuStatus,
    fastmenuData,
    companyData,
    loading,
}) => {
    const { t } = useTranslation()
    const [fasterMenuVisible, setFasterMenuVisible] = useState(false)
    const [fasterMenus, setFasterMenus] = useState<ItemType[]>([])
    const {
        getFastmenuData,
        updateFastmenuData,
        addFavoriteFastmenuData,
        leftMenuToggle,
    } = useActions()
    const language = localStorage.getItem('i18nextLng')
    const responsiveWidth = useResponsiveWidth()

    useEffect(() => {
        if (!loading) getFastmenuData()
    }, [companyData, loading])

    const returnFastermenuName = (value: string) => {
        switch (value) {
            case 'OWN_ACCOUNT':
                return t('transfers.internalToOwnAccount')
            case 'INTERNAL':
                return t('transfers.internalToOtherAccount')
            case 'EXCHANGE':
                return t('home.currencyExchange')
            case 'AZIPS':
                return 'AZİPS'
            case 'XOHKS':
                return 'XÖHKS'
            case 'DXA':
                return t('home.budgetSTA')
            case 'EDV':
                return t('home.budgetVAT')
            case 'IPS_OTH':
                return t('transfers.anipayNonBudget')
            case 'IPS_BDG':
                return t('transfers.aniPaySTA')
            case 'IPS_VAT':
                return t('transfers.aniPayVAT')
            case 'SWIFT':
                return t('home.foreignCurrencyTransfer')
            case 'SWIFT_RUB':
                return 'RUB'
            case 'TEMPLATE':
                return t('home.templates')
            case 'STATE_ACCOUNT':
                return t('accounts.accountsStatement')
            case 'CARILIST':
                return t('home.accounts')
            case 'STATE_CARD':
                return t('businessCards.cardAccountStatement')
            case 'CARDLIST':
                return t('home.businessCards')
            case 'SALARY_TOTAL':
                return t('fastMenu.salaryTransfer')
            case 'SALARY_EMP':
                return t('home.listOfEmployees')
            case 'STATE_SALARY':
                return t('fastMenu.salaryStatement')
            case 'EXTRE_ACCOUNT':
                return t('accounts.accountsStatement')
            case 'EXTRE_SALARY':
                return t('salary.salaryAccountStatement')
            case 'EXTRE_CARD_ACC':
                return t('businessCards.cardAccountStatement')
            case 'EXTRE_CARD_PIN':
                return t('businessCards.cardStatement')
            case 'GPP':
                return t('transfers.gpp')
            case 'BATCH_PAYMENT':
                return t('transfers.batchtransferswithoutsource')

            default:
                return value
        }
    }

    const returnFastermenuPath = (value: string) => {
        switch (value) {
            case t('fastMenu.salaryTransfer'):
                return '/salary/transfer'
            case t('home.listOfEmployees'):
                return '/salary/list'
            case t('transfers.internalToOwnAccount'):
                return '/new_transfer/inside_bank/own_account'
            case t('transfers.internalToOtherAccount'):
                return '/new_transfer/inside_bank/other_account'
            case t('home.currencyExchange'):
                return '/new_transfer/currency_exchange'
            case 'AZİPS':
                return '/new_transfer/domestic/azips'
            case 'XÖHKS':
                return '/new_transfer/domestic/hoks'
            case t('home.budgetSTA'):
                return '/new_transfer/domestic/dxa'
            case t('home.budgetVAT'):
                return '/new_transfer/domestic/edv'
            case t('transfers.anipayNonBudget'):
                return '/new_transfer/anipay/qbudce'
            case t('transfers.aniPaySTA'):
                return '/new_transfer/anipay/dxa'
            case 'AniPay - ƏDV':
                return '/new_transfer/anipay/edv'
            case t('home.foreignCurrencyTransfer'):
                return '/new_transfer/foreign_currency/money_transfer'
            case 'RUB':
                return '/new_transfer/foreign_currency/rub'
            case t('transfers.batchtransferswithoutsource'):
                return '/new_transfer/mass_transfers'
            case t('home.templates'):
                return '/new_transfer/templates'
            case t('home.accounts'):
                return '/accounts/accounts'
            case t('home.businessCards'):
                return '/business_cards/cards'
            case t('home.accountStatement'):
                return '/accounts/account_statement'
            case t('businessCards.cardAccountStatement'):
                return '/business_cards/card_account_statement'
            case t('accounts.accountsStatement'):
                return '/accounts/account_statement'
            case t('salary.salaryAccountStatement'):
                return '/salary/print'
            case t('businessCards.cardAccountStatement'):
                return '/business_cards/card_account_statement'
            case t('businessCards.cardStatement'):
                return '/business_cards/card_accountpan_statement'
            case t('transfers.gpp'):
                return '/new_transfer/gpp'
            default:
                return ''
        }
    }

    useEffect(() => {
        let i = 1
        const fasterMenusCash: ItemType[] = []
        fastmenuData.forEach(function (line: FasterMenuType) {
            if (line.trnType !== 'BULK_TRANSFER') {
                let title = returnFastermenuName(line.trnType)

                fasterMenusCash.push({
                    active: line.isInFavoriteList,
                    id: line.favoriteSeq,
                    trnType: line.trnType,
                    title: title,
                    path: returnFastermenuPath(title),
                })
                i++
            }
        })

        setFasterMenus((old_data) => fasterMenusCash)
    }, [fastmenuData, language])

    const dragProps = (value: any) => {
        const data = [...fasterMenus]

        const item = data.splice(value.oldIndex, 1)[0]

        if (item.active)
            updateFastmenuData({ trnType: item.trnType, index: value.newIndex })
    }

    // @ts-ignore
    const onChange = (checked, index) => {
        addFavoriteFastmenuData({
            trnType: fasterMenus[index].trnType,
            checked: checked,
            fastMenuList: fastmenuData,
        })
        fasterMenus[index].active = checked
        setFasterMenus([...fasterMenus])
    }

    const onSelect = (item) => {
        item.domEvent.target.parentElement?.parentElement?.classList.remove(
            'ant-menu-item-active'
        )
        item.domEvent.target.parentElement?.parentElement?.classList.remove(
            'ant-menu-item-selected'
        )
    }

    const div_class = leftMenuStatus ? 'flex justify_center' : ''

    const onHandleClickFasterMenuItem = () => {
        if (responsiveWidth < 992) {
            leftMenuToggle()
        }
    }

    return (
        <>
            <div className={`faster_menu ${div_class}`}>
                <p className="flex align_center">
                    <Icon className="bookmark_ico" component={() => <BookmarkIco />} />

                    {!leftMenuStatus && (
                        <>
                            <span>{t('home.fastMenu')}</span>

                            <Button
                                onClick={() => setFasterMenuVisible(true)}
                                className="add_faster_menu_btn transparent"
                                type="ghost"
                                icon={<FasterMenuIco />}
                            />
                        </>
                    )}
                </p>

                <Modal
                    title={t('home.fastMenuSetting')}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={fasterMenuVisible}
                    onOk={() => setFasterMenuVisible(false)}
                    okText={t('accountStatement.apply')}
                    okButtonProps={{ className: 'modal_ok_btn' }}
                    onCancel={() => setFasterMenuVisible(false)}
                    cancelText={'Ləğv et'}
                    cancelButtonProps={{ className: 'modal_cancel_btn' }}
                    width={450}
                    footer={false}
                    className={'manage_faster_menus manage_faster_menus_main'}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                >
                    {/*<ReactDragListView {...dragProps} lineClassName='draggable_div'>
                                <ul className='faster_menus_draggable flex direction_column' >
                                    {fasterMenus.map((row, index) => {
                                        let show_drag_icon=row.active ? 'show' : 'hide';

                                        return (
                                            <li key={`draggable2_li_${index}`}>
                                                <a href="#" className={show_drag_icon}>
                                                    <DraggableMoveUpDownIco />
                                                </a>
                                                <p>{row.title}</p>
                                                <Switch checked={row.active} onChange={(e) => onChange(e, index)} />
                                            </li>
                                        )
                                    })}
                                </ul>
                            </ReactDragListView>*/}

                    <ul className="faster_menus_draggable flex direction_column">
                        <ReactSortable
                            list={fasterMenus}
                            setList={setFasterMenus}
                            onUpdate={dragProps}
                        >
                            {fasterMenus?.map((row, index) => {
                                let show_drag_icon = row.active ? 'show' : 'hide'

                                return (
                                    <li key={`draggable2_li_${index}`}>
                                        <a href="#" className={show_drag_icon}>
                                            <DraggableMoveUpDownIco />
                                        </a>
                                        <p>
                                            {row.title === t('transfers.batchtransferswithoutsource') ? (

                                                <div className="oldword">
                                                    <span style={{ lineHeight: "40px" }}> {i18next.t('transfers.batchtransferswithoutsource')} </span>
                                                    <div style={{ display: "inline-block", position: "relative", top: '-10px', right: '2px' }}>
                                                        <span ></span>
                                                    </div>
                                                </div>

                                            ) : (
                                                row.title
                                            )}
                                        </p>
                                        <Switch
                                            checked={row.active}
                                            onChange={(e) => onChange(e, index)}
                                        />
                                    </li>
                                )
                            })}
                        </ReactSortable>
                    </ul>
                </Modal>
            </div>

            {!leftMenuStatus && (
                <Menu
                    className="faster_menu_list"
                    onSelect={onSelect}
                    selectable={false}
                >
                    {fasterMenus.map((row, index) => {
                        const newLocation = location.pathname
                        //.split("/").length-1 === 3 ? location.pathname.substring(0, location.pathname.lastIndexOf('/')) : location.pathname;
                        let menu_2_active_class =
                            newLocation == row.path ? 'fast_menu_active' : ''

                        if (
                            newLocation.toString().startsWith('/business_cards/cards') &&
                            row.path === '/business_cards/cards'
                        )
                            menu_2_active_class = 'fast_menu_active'

                        return (
                            row.active && (
                                <Menu.Item
                                    key={`faster_menus_${index}`}
                                    className={menu_2_active_class}
                                >
                                    <Link to={row.path} onClick={onHandleClickFasterMenuItem}>
                                        {row.title === t('transfers.batchtransferswithoutsource') ? (

                                            <div className="oldword">
                                                <span style={{ lineHeight: "40px" }}> {i18next.t('transfers.batchtransferswithoutsource')} </span>
                                                <div style={{ display: "inline-block", position: "relative", top: '-10px', right: '2px' }}>
                                                    <span></span>
                                                </div>
                                            </div>
                                        ) : (
                                            row.title
                                        )}
                                    </Link>
                                </Menu.Item>
                            )
                        )
                    })}
                </Menu>
            )}
        </>
    )
}

const mapDispatchToProps = { leftMenuToggle, getFastmenuData }

const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
    fastmenuData: state.fastmenu.fastmenuData.result ?? [],
    companyData:
        state.user && state.user.companyData.result
            ? state.user.companyData.result.customerNo
            : getCurrentCompany().customerNo,
    loading: state.user.isCompChange,
})

export default connect(mapStateToProps, mapDispatchToProps)(FasterMenus)
